import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ConfirmTextButton from '../atoms/ConfirmTextButton';

const styles = {
  textRed: {
    color: 'red'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  },
  textBlack: {
    color: 'black'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    openResult,
    updateOpenResult,
    closeAction,
    resultData,
    classes,
    isFukuoka
  }) => {
    console.log('resultData', resultData);
    console.log('resultData.length', resultData.length);
    let message = '';
    let num = 1;
    if (resultData.length > 0) {
      resultData.forEach(info => {
        if (!info.error && info.gochiCode) {
          message += `${num}${isFukuoka ? '.コード' : '.ごちコード'}${
            info.gochiCode
          }の消込を成功しました。<br />`;
        } else if (info.error && info.gochiCode) {
          message += `<span style="color: red">${num}${
            isFukuoka ? '.コード' : '.ごちコード'
          }${info.gochiCode}${
            isFukuoka ? 'の消込を失敗しました' : 'の消込に失敗しました。'
          }</span><br />`;
        } else if (info.message) {
          message += `${info.message}`;
        }
        num += 1;
      });
    }
    return (
      <Dialog
        open={openResult}
        onClose={() => {
          updateOpenResult(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={[classes.breakLine]}
          >
            <div
              className="content"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: message }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ConfirmTextButton onClickAction={closeAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
